module.exports = __webpack_public_path__ + "media/sounds/clear_piano-6b8714d44251639aad18c026a4e29966.wav";